import { ApiTags, rootApi } from "../../../../services/rootApi";

const TAG = ApiTags.ExtendGatePass;
export interface IExtended {
  id?: string
  toDate?: Date,
  fromDate?: Date,
  serviceRequestId?: string,
  gatePassId?: string,
  studentId?: string,
  approvalBy?: string,
  approvalToken?: string,
  approvalRequired?: boolean,
  multidaygprequired?: boolean,
  status?: number,
  otpTimer?: number,
  stateCode?: number,
  sendTime?: Date,
  counter?: number
}
export interface CustomConnections {
  customconnectionid?: string
  name?: string
  connectedTo?: string
  contact?: string
}

const getTags = (entities: IExtended[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.id })),
  TAG,
];
const getTags1 = (entities: CustomConnections[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.customconnectionid})),
  TAG,
];

const extendedApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getExtendedGatePass: builder.query<IExtended, { id: string }>({
      query: ({ id }) => `ExtendedGatePass/id(${id})`,
      providesTags: (result) => (result ? getTags([result]) : [TAG]),
    }),
    getCustomConnections: builder.query<CustomConnections[], { contact: string }>({
          query: ({contact}) => `/ExtendedGatePass/contact(${contact})`,
          providesTags: (result) => (result ? getTags1(result) : [TAG]),
        }),
    updateExtendedLine: builder.mutation<IExtended, Partial<IExtended>>({
      query: (lineId) => {
        return {
          url: `/ExtendedGatePass/${lineId.id}`,
          method: 'PUT',
          body: lineId
        }
      }
    }),
    updateApproveReject: builder.mutation<IExtended, Partial<IExtended>>({
      query: (lineId) => {
        return {
          url: `/ExtendedGatePass/ApproveReject/${lineId.id}`,
          method: 'PUT',
          body: lineId
        }
      }
    }),
    updateNoApproval: builder.mutation<IExtended, Partial<IExtended>>({
      query: (lineId) => {
        return {
          url: `/ExtendedGatePass/NoApproval/${lineId.id}`,
          method: 'PUT',
          body: lineId
        }
      }
    }),
    updateResendForModifiication: builder.mutation<IExtended, Partial<IExtended>>({
      query: (lineId) => {
        return {
          url: `/ExtendedGatePass/ResendForModification/${lineId.id}`,
          method: 'PUT',
          body: lineId
        }
      }
    }),
    resendApproval: builder.mutation<{ status: string, message: string }, string>({
      query: (lineId) => {
        return {
          url: `/ExtendedGatePass/ResendApprovalRequest/${lineId}`,
          method: 'POST'
        }
      }
    }),
  }),
});

export const {
  useGetExtendedGatePassQuery,
  useGetCustomConnectionsQuery,
  useLazyGetCustomConnectionsQuery,
  useLazyGetExtendedGatePassQuery,
  useUpdateExtendedLineMutation,
  useResendApprovalMutation,
  useUpdateApproveRejectMutation,
  useUpdateNoApprovalMutation,
  useUpdateResendForModifiicationMutation,
} = extendedApi;
